import { render, staticRenderFns } from "./AddPlatformComponent.vue?vue&type=template&id=68532b38&"
import script from "./AddPlatformComponent.vue?vue&type=script&lang=js&"
export * from "./AddPlatformComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports